// Shared badge colour + i18n label key for a gradebook/pauta's `status`
// field (DRAFT/FINALIZED/PUBLISHED/CHANGE — as returned by sge_infantil_core),
// used by LancamentoNotasLayer, ListaNotasLayer and PautasLayer so the three
// screens show the same colours and Portuguese wording instead of the raw
// English backend value.
export const GRADEBOOK_STATUS_BADGE = {
  DRAFT: "bg-warning-focus text-warning-main",
  FINALIZED: "bg-info-focus text-info-main",
  PUBLISHED: "bg-success-focus text-success-main",
  CHANGE: "bg-danger-focus text-danger-main",
};

export const GRADEBOOK_STATUS_LABEL_KEY = {
  DRAFT: "nota.status.draft",
  FINALIZED: "nota.status.finalized",
  PUBLISHED: "nota.status.published",
  CHANGE: "nota.status.change",
};
